export var EventNotificationStatus;
(function (EventNotificationStatus) {
    EventNotificationStatus["Draft"] = "Draft";
    EventNotificationStatus["Pending"] = "Pending";
    EventNotificationStatus["Accepted"] = "Accepted";
    EventNotificationStatus["PartiallyAccepted"] = "PartiallyAccepted";
    EventNotificationStatus["Rejected"] = "Rejected";
})(EventNotificationStatus || (EventNotificationStatus = {}));
export class EventNotificationStatusHelper {
    static getName(status) {
        switch (status) {
            case EventNotificationStatus.Draft:
                return $t('%Az');
            case EventNotificationStatus.Pending:
                return $t('%B0');
            case EventNotificationStatus.Accepted:
                return $t('%B1');
            case EventNotificationStatus.PartiallyAccepted:
                return $t('%Ck');
            case EventNotificationStatus.Rejected:
                return $t('%B2');
        }
    }
}
//# sourceMappingURL=EventNotificationStatus.js.map